// validateCartMiddleware.js
const validateCartMiddleware = (store) => (next) => (action) => {
    const cartActions = ['cart/addToCart', 'cart/increaseToCart', 'cart/decreaseToCart'];

    if (cartActions.includes(action.type)) {
        const prod = action.payload;

        // Correction automatique ou avertissement
        if (prod.numPV == null || typeof prod.numPV !== 'number') {
            console.warn(`[Cart] numPV manquant ou invalide pour le produit :`, prod);
            action.payload.numPV = 0; // valeur par défaut
        }

        if (prod.price == null || typeof prod.price !== 'number') {
            console.warn(`[Cart] price manquant ou invalide pour le produit :`, prod);
            action.payload.price = 0; // valeur par défaut
        }

        if (!prod._id) {
            console.error(`[Cart] _id requis pour le produit :`, prod);
            return; // stoppe l'action
        }
    }

    return next(action);
};

export default validateCartMiddleware;
